var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.user.unique_name)+" is logged in")]),_c('parameter',{ref:"param",on:{"error":_vm.onError,"data":_vm.onData,"id":_vm.onId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }